import React, { useEffect, useState } from "react";
import { FiLogOut, FiRefreshCw, FiShield } from "react-icons/fi"; // ⬅️ tambah FiShield
import "./Navbar.css";
import imageCompression from "browser-image-compression";
import {
    getStorage,
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject,
} from "firebase/storage";
import {
    doc,
    updateDoc,
    collection,
    query,
    where,
    onSnapshot,
} from "firebase/firestore";
import { db } from "../services/firebase";
import { useNavigate } from "react-router-dom";





const Navbar = ({ onLogout }) => {
    const [user, setUser] = useState(null);
    const [pendingSchoolsCount, setPendingSchoolsCount] = useState(0); // ⬅️ noti count
    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        setUser(storedUser);
    }, []);

    useEffect(() => {
        if (!user?.isSuperAdmin) return;

        const q = query(
            collection(db, "schools"),
            where("approved", "==", false)
        );

        const unsub = onSnapshot(q, (snap) => {
            setPendingSchoolsCount(snap.size); // jumlah sekolah belum lulus
        });

        return () => unsub();
    }, [user]);


    const handleRefresh = () => {
        window.location.reload(); // Refresh the page
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file || !user) return;

        try {
            // === 1. Compress Image ===
            const compressedFile = await imageCompression(file, {
                maxSizeMB: 1,
                maxWidthOrHeight: 1024,
                useWebWorker: true,
            });

            // === 2. Generate new path ===
            const storage = getStorage();
            const newPath = `avatars/${user.id}_${Date.now()}.jpg`;
            const newRef = ref(storage, newPath);

            // === 3. Upload compressed image ===
            await uploadBytes(newRef, compressedFile);
            const downloadURL = await getDownloadURL(newRef);

            // === 4. Delete old image if exists ===
            const oldAvatarURL = user.avatar;
            if (oldAvatarURL && oldAvatarURL.includes("/o/")) {
                try {
                    const oldPath = decodeURIComponent(new URL(oldAvatarURL).pathname.split("/o/")[1].split("?")[0]);
                    const oldRef = ref(storage, oldPath);
                    await deleteObject(oldRef);
                } catch (err) {
                    console.warn("Gagal padam gambar lama:", err.message);
                }
            }


            // === 5. Update Firestore & localStorage ===
            const docRef = doc(db, user.role === "teacher" ? "teachers" : "students", user.id);
            await updateDoc(docRef, { avatar: downloadURL });

            const updatedUser = { ...user, avatar: downloadURL };
            localStorage.setItem("user", JSON.stringify(updatedUser));
            setUser(updatedUser);
        } catch (error) {
            console.error("Avatar upload failed:", error);
            alert("Gagal tukar gambar. Sila cuba lagi.");
        }
    };

    const role = user?.role;


    return (
        <nav className="navbar">
            {user && (
                <div className="navbar-content">
                    <div className="user-info">
                        <label htmlFor="avatar-upload">
                            <img
                                src={
                                    user.avatar ||
                                    `${process.env.PUBLIC_URL}/assets/profile-user.png`
                                }
                                className="avatar"
                                alt="User Avatar"
                                title="Klik untuk tukar gambar"
                                style={{ cursor: "pointer" }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `${process.env.PUBLIC_URL}/assets/profile-user.png`;
                                }}
                            />

                        </label>
                        <input
                            id="avatar-upload"
                            type="file"
                            accept="image/*"
                            capture="user"
                            style={{ display: "none" }}
                            onChange={handleImageChange}
                        />


                        <div className="user-details">
                            <span className="user-name" title={user.name}>
                                {user.name}
                            </span>
                            <span
                                className={`user-role-badge ${role === "teacher" ? "badge-guru" : "badge-murid"}`}
                            >
                                {role === "teacher" ? "Guru" : "Murid"}
                            </span>
                        </div>
                    </div>

                    <div className="navbar-actions">
                        {/* Super Admin Icon */}
                        {user?.isSuperAdmin && (
                            <div
                                className="superadmin-icon-wrapper"
                                onClick={() => navigate("/super-admin")}
                                title="Admin Sistem"
                            >
                                <FiShield size={20} />
                                {pendingSchoolsCount > 0 && (
                                    <span className="superadmin-badge">
                                        {pendingSchoolsCount}
                                    </span>
                                )}
                            </div>
                        )}

                        {/* Refresh Icon */}
                        <div onClick={handleRefresh} style={{ color: "white", margin: "0 5px" }} title="Refresh">
                            <FiRefreshCw size={20} />
                        </div>

                        {/* Logout Icon */}
                        <div onClick={onLogout} style={{ color: "white", margin: "0 5px" }} title="Log Keluar">
                            <FiLogOut size={20} />
                        </div>
                    </div>


                </div>
            )}
        </nav>
    );
};

export default Navbar;
